export interface RuntimeConfig {
  serverUrl: string;
  partnerAuth: string;
  authAudience: string;
  authDomain: string;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const windowAdvoConfig = window.ADVO_CONFIG as RuntimeConfig;

const runtimeConfig: RuntimeConfig =
  process.env.NODE_ENV === "production"
    ? windowAdvoConfig
    : {
        serverUrl: "",
        partnerAuth: "OS",
        authDomain: "https://legalvisio-dev.eu.auth0.com",
        authAudience: "EimnaRrdo7j1bAk1lfarTrZo9IVCLDTe",
      };

export default runtimeConfig;
